import { status } from 'constants/general';

export const initialCommonState = {
  context: '',
  labsList: {
    status: status.SHOULD_CALL_API,
    details: [],
  },
  chemistsList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  usersList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  uploadContentSubmission: {
    status: status.SHOULD_CALL_API,
  },
};

export const initialAccountManagementState = {
  userAuthenticationInfo: {
    status: status.SHOULD_CALL_API,
    details: [],
  },
  loginInfo: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  permissions: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};

export const initialLaboratoriesState = {
  laboratoriesList: {
    status: status.SHOULD_CALL_API,
    details: [],
  },
};

export const initialMasterListState = {
  ServicesList: {
    status: status.SHOULD_CALL_API,
    details: [],
  },
};

export const initialOrdersState = {
  ordersList: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  detailedReasons: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  orderDetails: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  orderDispensedItems: [],
  assignOrderToEntity: {
    status: status.SHOULD_CALL_API,
  },
  orderServicesSuggestions: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  orderServicesSubmission: {
    status: status.SHOULD_CALL_API,
  },
  orderStatusChangeSubmission: {
    status: status.SHOULD_CALL_API,
  },
  orderNoteChangeSubmission: {
    status: status.SHOULD_CALL_API,
  },
  scheduleOrderSubmission: {
    status: status.SHOULD_CALL_API,
  },
  scheduleOrderReasons: {
    status: status.SHOULD_CALL_API,
  },
  cancelOrderReasons: {
    status: status.SHOULD_CALL_API,
  },
};
